export default __webpack_public_path__ + "static/media/flower5.f6803fae.jpg";